import { Directive, effect, inject, signal, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[coreAuthHasGroup]',
})
export class HasGroupDirective {
  private _authService = inject(AuthService);
  private _viewContainer = inject(ViewContainerRef);
  private _templateRef = inject(TemplateRef<any>);
  private _show = signal(false);

  @Input({ alias: 'coreAuthHasGroup' })
  set groupCheck(requiredGroups: string | string[]) {
    const hasAccess = this._authService.isInGroup(requiredGroups);
    this._show.set(hasAccess);
  }

  constructor() {
    effect(() => {
      this._viewContainer.clear();
      if (this._show()) {
        this._viewContainer.createEmbeddedView(this._templateRef);
      }
    });
  }
}
